import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import CreatableSelect from 'react-select/creatable';

const PipeStringInput = ({
  onChange,
  value = '',
  isDisabled = false,
  name,
  placeholder = 'Skriv och tryck enter för att skapa ny',
  required = false,
  parentEntity,
}) => {
  const selectValue =
    !_.isEmpty(value) && value.split('|').map(x => ({ value: x, label: x }));

  const handleChange = inputvalue => {
    // Capitalize each word in the string to ensure sorting is correct
    const pipeString = inputvalue.map(x => _.capitalize(x.value)).join('|');
    onChange(name, pipeString);
  };

  const currentOptions = parentEntity.categories.map(x => {
    const formattedName = x.name?.replace(/\|/g, ' > ');
    return { value: x.name, label: formattedName };
  });

  return (
    <CreatableSelect
      isMulti
      name={name}
      isDisabled={isDisabled}
      onChange={handleChange}
      value={selectValue}
      required={required}
      placeholder={placeholder}
      options={currentOptions}
      createOptionPosition="first"
      formatCreateLabel={inputValue => `Skapa ny kategori: ${inputValue}`}
    />
  );
};

PipeStringInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  isDisabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  isClearable: PropTypes.bool,
  options: PropTypes.array,
};

export default PipeStringInput;
